module.exports = __webpack_public_path__ + "build/desktop/img/mir.83a14559e615f0c391baa862ef3546ec.svg";